<mat-form-field (click)="openOverlay()" #trigger class="hdis-asset-picker-form-field" [class.disabled]="readonly">
  <mat-label>{{label}}</mat-label>
  <input matInput *ngIf="inline" [value]="formattedValue" readonly>
  <textarea matInput *ngIf="!inline" cdkOverlayOrigin #trigger="cdkOverlayOrigin" cdkTextareaAutosize
    #autosize="cdkTextareaAutosize" disabled>{{formattedValue}}</textarea>
</mat-form-field>
